<template>
  <div class="dados-operadora">
    <Card title="Dados Operadora">
        <lista-component :headers="headers" :items="analise" color="red--text text--lighten-1" />
    </Card>
  </div>
</template>
<script>
import Card from "@/components/Cards/Card";
import ListaComponent from "@/components/Lista/ListaComponent";

export default {
  name: "DadosOperadora",
  props: {
    analise: {
      type: Object,
      required: true
    }
  },
  components: { Card, ListaComponent },
  data(){
    return {
      headers: [
        { text: 'Placa Original', value: 'placa_original'},
        { text: 'UF Placa Original', value: 'uf_placa_original'},
        { text: 'Marca/Modelo Original', value: 'marca_modelo_original'},
        { text: 'Tipo Veículo Original', value: 'tipo_veiculo_original'},
        { text: 'Cor Original', value: 'cor_original'},
        { text: 'Ano Fabricação Original', value: 'ano_fabricacao_original'},
        { text: 'Ano Modelo Original', value: 'ano_modelo_original'},
      ]
    }
  },
};
</script>